export const OPTHINES = {
  voteName: '2020project/2020ninedream',
  mustSearch: 'Button',
  buttonBg: 'rgb(250, 73, 59)',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
  themeColor: {
    activeBgColor: '#BD0331',
    inactiveBgColor: '#FA493B',
  },
  tabs: [
    {
      tabName: '作品展示',
      tabPath: '/20200118JTYM/List',
    },
    {
      tabName: '活动规则',
      tabPath: '/20200118JTYM/Rules',
    },
    {
      tabName: '活动排名',
      tabPath: '/20200118JTYM/Ranking',
    },
    {
      tabName: '我的作品',
      tabPath: '/20200118JTYM/User',
    },
  ],
};
